import {SWITCH_TO_RESOURCE, RESET_SWITCH_RESOURCE} from './types';

export default function (resourceName) {
	return (state, action) => {
		if (action.resourceName !== resourceName) {
			return state;
		}

		switch (action.type) {
			case SWITCH_TO_RESOURCE:
				return {
					...state,
					switchValue: action.value
				};
			case RESET_SWITCH_RESOURCE:
				return {
					...state,
					switchValue: null
				};
			default:
				return state;
		}
	};
}



// WEBPACK FOOTER //
// ./src/client/redux/redux-resource-plugins/switch/index.js